import { render } from "./TruePuzzleBoard.vue?vue&type=template&id=7eada419&scoped=true"
import script from "./TruePuzzleBoard.vue?vue&type=script&lang=js"
export * from "./TruePuzzleBoard.vue?vue&type=script&lang=js"

import "./TruePuzzleBoard.vue?vue&type=style&index=0&id=7eada419&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7eada419"]])

export default __exports__